import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import PromotionsTable from './components/PromotionsTable';
import BreadCrumb from '../../shared/components/BreadCrumb';

const MaterialTable = () => (
  <Container>
    <Row>
      <Col md={12}>
        <BreadCrumb title="Promotions"/>
      </Col>
    </Row>
    <Row>
      <PromotionsTable />
    </Row>
  </Container>
);

export default MaterialTable;
